module.exports = __webpack_public_path__ + "static/lavora_con_noi-6bb3d2cb48835d182c34e291dcdb32f2.jpg";